import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

// Validate environment variables - log warnings instead of throwing
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase credentials:', {
    hasUrl: !!supabaseUrl,
    hasKey: !!supabaseAnonKey
  });
}

// Validate URL format
if (supabaseUrl && !supabaseUrl?.startsWith('http://') && !supabaseUrl?.startsWith('https://')) {
  console.error('❌ Invalid Supabase URL format:', supabaseUrl);
}

// Use fallback values to prevent module crash - client will fail gracefully on actual requests
const safeUrl = (supabaseUrl && (supabaseUrl?.startsWith('http://') || supabaseUrl?.startsWith('https://')))
  ? supabaseUrl
  : 'https://placeholder.supabase.co';

const safeKey = supabaseAnonKey || 'placeholder-key';

if (supabaseUrl && supabaseAnonKey) {
  console.log('✅ Supabase client initializing with URL:', supabaseUrl?.substring(0, 30) + '...');
}

export const supabase = createClient(safeUrl, safeKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  global: {
    headers: {
      'X-Client-Info': 'adt-tracking-app'
    }
  },
  db: {
    schema: 'public'
  }
});
